import { motion } from "framer-motion";
import { Phone, Search, Wrench, ThumbsUp } from "lucide-react";
import Reveal from "@/components/motion/Reveal";

const CHAPTERS = [
  { n: "01", icon: Phone, title: "Kontakt aufnehmen", desc: "Ruf an oder schreib uns per WhatsApp. Du schilderst dein Anliegen – wir nennen dir direkt Preis und Zeitfenster." },
  { n: "02", icon: Search, title: "Diagnose & Angebot", desc: "Wir analysieren dein Fahrzeug präzise und machen dir eine transparente, faire Ansage. Keine versteckten Kosten." },
  { n: "03", icon: Wrench, title: "Mobil erledigt", desc: "Ob Tuning, Elektronik oder Schlüssel – wir kommen mit der passenden Technik direkt zu dir vor Ort." },
  { n: "04", icon: ThumbsUp, title: "Zufrieden weiterfahren", desc: "Funktionstest, kurze Einweisung, fertig. Du bist wieder unterwegs – schnell und ohne Umwege." },
];

export default function Process() {
  return (
    <section id="ablauf" className="relative bg-[#080808] py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr]">
          <Reveal>
            <p className="mb-4 flex items-center gap-3 font-body text-[11px] font-bold uppercase tracking-[0.3em] text-volt">
              <span className="h-px w-10 bg-volt" /> So läuft's ab
            </p>
            <h2 className="font-heading text-4xl font-black uppercase leading-[0.9] tracking-tight text-white sm:text-6xl">
              In 4 Schritten<br />zum Ziel
            </h2>
            <p className="mt-6 max-w-md font-body text-base text-neutral-400">
              Unkompliziert, transparent und schnell. Kein Papierkram, keine langen
              Wartezeiten – nur ehrliche Arbeit direkt bei dir vor Ort.
            </p>
          </Reveal>

          <div className="space-y-px">
            {CHAPTERS.map((c, i) => (
              <motion.div
                key={c.n}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="group flex items-start gap-6 border-t border-white/10 py-7 first:border-t-0"
              >
                <span className="font-heading text-4xl font-black text-neutral-700 transition-colors group-hover:text-volt sm:text-5xl">
                  {c.n}
                </span>
                <div className="flex-1">
                  <div className="flex items-center gap-3">
                    <c.icon className="h-5 w-5 text-volt" />
                    <h3 className="font-heading text-2xl font-extrabold uppercase text-white">{c.title}</h3>
                  </div>
                  <p className="mt-2 font-body text-sm text-neutral-400">{c.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
